import clsx from 'clsx';
import Button from 'components/Button/Button';
import TextField from 'components/TextField/TextField';
import { BUTTON_VARIANT } from 'constants/interfaces';

import type IEditTopicName from './interfaces/IEditTopicName';

import styles from './scss/EditTopicName.module.scss';

function EditTopicName({
  text,
  placeholder,
  onChangeText,
  onSave,
  onCancel,
  saveTitle,
  cancelTitle,
  keyWordsType,
}: IEditTopicName) {
  return (
    <div className={clsx(styles.editWrapper, { [styles.keyWordsType]: keyWordsType })}>
      <TextField
        name="editTopicName"
        value={text}
        onChange={(event) => onChangeText(event.target.value)}
        placeholder={placeholder}
        className={styles.textField}
      />
      <Button
        title={saveTitle}
        variant={BUTTON_VARIANT.primary}
        onClick={onSave}
      />
      <Button
        title={cancelTitle}
        variant={BUTTON_VARIANT.error}
        onClick={onCancel}
      />
    </div>
  );
}

export default EditTopicName;
